import SetupAccount from "./setupaccount";

export default SetupAccount;
